import { observer } from 'mobx-react-lite';
import React from 'react';
import { Form, Header, Radio, Segment } from 'semantic-ui-react';

import { IAssessmentQuestion } from '../../Models/AssessmentQuestion';

interface AssessmentQuestionProps {
  question: IAssessmentQuestion;
  key?: string;
  index?: number;
}

const AssessmentQuestionComponent: React.FC<AssessmentQuestionProps> = (
  props
) => {
  const { question } = props;
  const answer = question.answer;
  const timeToComplete = question.timeToComplete;

  const handleAnswer = (e: any) => {
    question.setAnswer(e.target.innerText);
  };
  const handleTimeToComplete = (e: any) => {
    question.setTimeToComplete(e.target.innerText);
  };

  return (
    <Segment textAlign='left' basic>
      <>
        <Form>
          <Form.Field>
            <Header>{question.question}</Header>
          </Form.Field>
          <Form.Field>
            <Radio
              label='Yes'
              name='radioGroup'
              value='Yes'
              checked={answer === 'Yes'}
              onChange={(e) => handleAnswer(e)}
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label='No'
              name='radioGroup'
              value='No'
              checked={answer === 'No'}
              onChange={(e) => handleAnswer(e)}
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label='N/A'
              name='radioGroup'
              value='N/A'
              checked={answer === 'N/A'}
              onChange={(e) => handleAnswer(e)}
            />
          </Form.Field>
        </Form>
        {question.answer === 'No' && (
          <Form>
            <Form.Field>
              <Header>When do you plan to complete this task?</Header>
            </Form.Field>
            <Form.Field>
              <Radio
                label='1 month'
                name='radioGroup'
                value={1}
                checked={timeToComplete === '1 month'}
                onChange={(e) => handleTimeToComplete(e)}
              />
            </Form.Field>
            <Form.Field>
              <Radio
                label='3 month'
                name='radioGroup'
                value={3}
                checked={timeToComplete === '3 month'}
                onChange={(e) => handleTimeToComplete(e)}
              />
            </Form.Field>

            <Form.Field>
              <Radio
                label='6 month'
                name='radioGroup'
                value={6}
                checked={timeToComplete === '6 month'}
                onChange={(e) => handleTimeToComplete(e)}
              />
            </Form.Field>
            <Form.Field>
              <Radio
                label='12 month +'
                name='radioGroup'
                value={12}
                checked={timeToComplete === '12 month +'}
                onChange={(e) => handleTimeToComplete(e)}
              />
            </Form.Field>
          </Form>
        )}
      </>
    </Segment>
  );
};

export default observer(AssessmentQuestionComponent);
